/**
 * Första inloggningen: Q-assistenten öppnas av sig själv en gång per person (på enheten), som ett blad över
 * resten. Minnet ligger i localStorage per Qid-sub. Den som redan pratat med Q (sparad historik, qClient.ts)
 * räknas som att ha sett den.
 */

type Store = Pick<Storage, 'getItem' | 'setItem'>;

const introKey = (sub: string) => `qvestium_q_intro_${sub}`;
const historyKey = (sub: string) => `qvestium_q_history_${sub}`;

const defaultStore = (): Store | null => {
  try { return typeof localStorage === 'undefined' ? null : localStorage; } catch { return null; }
};

/** Ska Q öppnas av sig själv för den här personen? */
export function shouldAutoOpenQ(sub: string, store: Store | null = defaultStore()): boolean {
  if (!sub || !store) return false;
  try {
    if (store.getItem(introKey(sub))) return false;
    const history = store.getItem(historyKey(sub));
    return !(history && /"role"/.test(history));
  } catch {
    return false;
  }
}

/**
 * Q har öppnats av sig själv: inte igen för den här personen. false om minnet inte gick att spara; då öppnas
 * Q inte heller, annars skulle den öppnas vid varje besök.
 */
export function markQIntroSeen(sub: string, store: Store | null = defaultStore()): boolean {
  try {
    if (!store) return false;
    store.setItem(introKey(sub), new Date().toISOString());
    return true;
  } catch {
    return false;
  }
}

/** Öppnar Q om det är personens första gång. Returnerar om den ska öppnas. */
export function claimQIntro(sub: string, store: Store | null = defaultStore()): boolean {
  return shouldAutoOpenQ(sub, store) && markQIntroSeen(sub, store);
}
